// i18n area 'tasks' — locale tr-TR (task #171, onda 5): tradotto DALL'ITALIANO,
// che è la lingua SORGENTE (regola ratificata 2026-08-03); gli anglicismi del
// sorgente si TRASLANO, non si traducono. Sidecar anti-stantie: ../meta/tasks.tr-TR.meta.json.
import type { enUS } from './tasks'

export const trTR: typeof enUS = {
  macrotasks: {
    title: 'Makro görevler',
    subtitle: 'Bileşik işlemler — başarısız adımdan sürdürülebilir ya da tümü geri alınabilir',
    colType: 'Tür',
    colTarget: 'Nesne',
    colPhase: 'Aşama',
    colSteps: 'Adımlar',
    empty: 'Makro görev yok',
    detail: 'Ayrıntılar',
    failedAt: 'başarısız adım',
    resume: 'Başarısız adımdan yeniden dene',
    abort: 'Tümünü geri al',
    cancel: 'İptal et',
    actionError: 'Eylem reddedildi'
  },
  tasks: {
    title: 'Görevler',
    searchPlaceholder: 'Türe veya hedefe göre ara',
    type: 'Tür',
    target: 'Hedef',
    phaseLabel: 'Aşama',
    progress: 'İlerleme',
    started: 'Başladı',
    finished: 'Bitti',
    node: 'Düğüm',
    empty: 'Görev yok',
    loadError: 'Görevler yüklenemedi — TVirt arka ucu erişilebilir mi?',
    limboHint: "'{node}' düğümüne {time} zamanından beri erişilemiyor — görev, düğüm geri dönene ya da kapalı beyan edilene kadar hedefinin write lease'ini elinde tutar",
    nodeAttested: 'Düğüm kapalı beyan edildi',
    phase: {
      queued: 'Kuyrukta',
      running: 'Çalışıyor',
      succeeded: 'Tamamlandı',
      failed: 'Başarısız',
      cancelled: 'İptal edildi',
      'failed-at-step': 'Bir adımda başarısız',
      aborted: 'Kesildi'
    },
    dropdown: {
      tooltip: 'Devam eden görevler',
      title: 'Devam eden görevler',
      empty: 'Devam eden görev yok',
      viewAll: 'Tüm görevleri gör'
    },
    detail: {
      open: 'Ayrıntılar',
      scope: 'Kapsam',
      message: 'Mesaj',
      params: 'Parametreler',
      result: 'Sonuç',
      errorTitle: 'Hata',
      steps: 'Adımlar',
      failedAt: 'başarısız adım',
      superseded: 'yenisiyle değiştirildi',

      // Standart dialog (round #156).
      step: 'Adım',
      parent: 'Üst görev',
      failedStep: 'Başarısız adım',
      log: 'Günlük',
      logEmpty: 'Henüz günlük girdisi yok',
      close: 'Kapat'
    },
    actions: {
      cancel: 'İptal et',
      resume: 'Başarısız adımdan yeniden dene',
      abort: 'Tümünü geri al (tamamlanan adımlar geri alınır)',
      refused: 'Eylem reddedildi'
    }
  },
  events: {
    loadError: 'Günlük yüklenemedi — TVirt arka ucu erişilebilir mi?',
    title: 'Olaylar',
    subtitle: 'Kümenin tarihsel belleği: olup bitmiş olgular, en yeniden başlayarak',
    filterSeverity: 'Önem',
    filterCategory: 'Kategori',
    filterAll: 'Tümü',
    searchLabel: 'Ara',
    searchPlaceholder: 'Tüm günlükte ara',
    subjectFilter: '{subject} olayları — tümünü göster',
    colAt: 'Ne zaman',
    colSeverity: 'Önem',
    colType: 'Tür',
    colSubject: 'Özne',
    colActor: 'Kim',
    colNode: 'Node',
    colMessage: 'Mesaj',
    empty: 'Olay yok',
    loadMore: 'Daha fazla yükle',
    actorSystem: 'sistem',
    detailScope: 'Scope',
    detailTask: 'Task',
    detailId: 'Olay kimliği',
    taskCollectedHint: 'Task daha kısa saklanır: toplandıktan sonra bağlantı yanıt vermez',
    severity: {
      info: 'Bilgi',
      warning: 'Uyarı',
      error: 'Hata',
      critical: 'Kritik'
    },
    category: {
      lifecycle: 'Yaşam döngüsü',
      config: 'Yapılandırma',
      availability: 'Erişilebilirlik',
      security: 'Güvenlik'
    },
    type: {
      haNetsvcFailedOver: 'Ağ hizmeti yük devretti',
      haNetsvcNoCandidate: 'Aday düğümü olmayan ağ hizmeti',
      haNetsvcReaped: 'Yerel örnek, düğüm geri dönünce biçildi',
      netsvcFloatipMoved: 'Yüzen IP başka bir tutucuya taşındı',
      netsvcFloatipNoHolder: 'Sağlıklı hedefi olmayan yüzen IP',
      haAppFailedOver: 'App örneği failover',
      haAppNoCandidate: 'Aday düğümü olmayan App örneği',
      haAppStorageLocalSkip: 'App örneği taşınmadı: kalıcı veriler ölü düğümde yerel',
      haAppReaped: "App örneğinin yerel pod'u yeniden katılımda biçildi"
    }
  },
  audit: {
    loadError: 'Denetim kaydı yüklenemedi — TVirt arka ucu erişilebilir mi?',
    title: 'Denetim',
    subtitle: 'Kim ne yaptı, ne zaman, hangi nesne üzerinde — reddedilenler dahil, denenen işlemler',
    filterOutcome: 'Sonuç',
    filterAll: 'Tümü',
    filterSudo: 'Yalnızca yükseltilmiş işlemler',
    colAt: 'Ne zaman',
    colActor: 'Kim',
    colAction: 'İşlem',
    colTarget: 'Nesne',
    colOutcome: 'Sonuç',
    colNode: 'Node',
    empty: 'Kayıtlı işlem yok',
    loadMore: 'Daha fazla yükle',
    sudoBadge: 'sudo',
    tokenBadge: 'app token',
    detailScope: 'Scope',
    detailPath: 'Rota',
    detailProblem: 'Neden',
    detailTask: 'Task',
    detailClientIp: 'Nereden',
    detailId: 'Kayıt kimliği',
    detailSession: 'Oturum',
    taskHint: 'Kabul edilen bir işlemin sonucu, aynı task kimliği altında olay günlüğünde yaşar',
    outcome: {
      succeeded: 'Başarılı',
      accepted: 'Kabul edildi',
      denied: 'İzin verilmedi',
      rejected: 'Reddedildi',
      failed: 'Başarısız'
    }
  },
  notifications: {
    loadError: 'Bildirimler yüklenemedi — TVirt arka ucu erişilebilir mi?',
    actionError: 'Eylem reddedildi',
    title: 'Bildirimler',
    subtitle: 'Günlüğün olgularının kümeden çıktığı hedefler',
    rulesTitle: 'Kurallar',
    rulesSubtitle: 'Hangi olgular çıkıyor ve nereye',
    deliveriesTitle: 'Teslimler',
    deliveriesSubtitle: 'Her bildirimin sonucu, başarısız olduğunda nedeniyle birlikte',
    colName: 'Ad',
    colKind: 'Tür',
    colWhere: 'Nereye',
    colScope: 'Scope',
    colSeverity: 'Önem',
    colMatch: 'Filtre',
    colTargets: 'Hedef',
    colAt: 'Ne zaman',
    colState: 'Durum',
    colEvent: 'Olay',
    colAttempts: 'Denemeler',
    colOutcome: 'Sonuç',
    empty: 'Satır yok',
    matchAll: 'tüm olgular',
    test: 'Sına',
    testOk: 'Sınama bildirimi {target} hedefine teslim edildi',
    testFailed: '{target} hedefine sınama başarısız: {reason}',
    retry: 'Kuyruğa geri koy',
    retried: 'Teslim kuyruğa geri kondu',
    grouped: 've {count} yineleme daha',
    state: {
      failed: 'Başarısız',
      pending: 'Kuyrukta',
      sending: 'Gönderiliyor',
      sent: 'Gönderildi'
    },
    tabTargets: 'Hedefler',
    tabRules: 'Kurallar',
    tabDeliveries: 'Teslimler',
    targetCreateTitle: 'Yeni hedef',
    ruleCreateTitle: 'Yeni kural',
    nameHint: 'Küçük harfler, rakamlar ve kısa çizgiler; kapsam başına tekil',
    kindImmutableHint: 'Değiştirilemez: türü değiştirmek başka bir hedef oluşturmak demektir',
    kindSmtp: 'Posta (SMTP)',
    kindWebhook: 'Webhook',
    enabled: 'Durum',
    enabledOn: 'Etkin',
    enabledOff: 'Askıya alındı',
    smtpHost: 'SMTP sunucusu',
    smtpPort: 'Port',
    smtpPortHint: 'Alışılmış: TLS olmadan 25, starttls ile 587, tls ile 465',
    smtpSecurity: 'Güvenlik',
    smtpFrom: 'Gönderen',
    smtpTo: 'Alıcılar',
    smtpToHint: 'Virgülle ayrılmış bir veya daha fazla adres',
    webhookUrl: 'URL',
    payload: 'İçerik',
    payloadHint: 'minimal ile olayın mesajı ve verileri kümeden çıkmaz',
    credential: 'Kimlik bilgisi',
    credentialNone: 'Yok',
    credentialHintSmtp: 'Anahtar deposundaki relay hesabı; yok anonim SMTP anlamına gelir',
    credentialHintWebhook: "Anahtar deposundaki imzalama sırrı; imza olmadan URL'yi bilen herkes kendini küme gibi gösterebilir",
    minSeverityHint: 'Bir eşik, bir küme değil: bu önem derecesinden yukarısı',
    categories: 'Kategoriler',
    categoriesHint: 'Boş = tümü',
    types: 'Olay türleri',
    typesHint: 'Virgülle ayrılmış; boş = tümü. Bilinmeyen tür reddedilir',
    targetsHint: 'En az bir; kuralın kapsamında ya da bir atasında olmalıdır',
    recursiveOn: 'Alt kapsamlar da',
    recursiveOff: 'Yalnızca bu kapsam',
    recursiveHint: 'Kaynaklar yapraklarda yaşar: alt kapsamlar olmadan kökteki bir kural neredeyse hiçbir şeyi bildirmez',
    repeatWindow: 'Gruplama penceresi (s)',
    repeatWindowHint: 'Pencere içinde yinelemeler posta göndermez: ilkinde sayılır. 0 kapatır',
    targetInUseError: '{name} hedefi hâlâ bir kural tarafından kullanılıyor'
  }
}
